import * as React from 'react'
import { Box, FormControl, Select, MenuItem, Typography, InputLabel } from '@mui/material'
import { renderColorByString } from 'components/DataGrid/renderColorByString'

type Option<T extends string = string> = { value: T; label: string }

type Props<T extends string = string> = {
  value: T
  onChange: (v: T) => void
  options: Option<T>[]
  label?: string
  ariaLabel?: string
  minWidth?: number
  maxWidth?: number
}

export default function FilterSelect<T extends string = string>({
  value,
  onChange,
  options,
  label,
  ariaLabel = 'filter',
  minWidth = 105,
  maxWidth = 115,
}: Props<T>) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
      <FormControl
        size="small"
        variant="standard"
        sx={{
          minWidth,
          maxWidth,
          '& .MuiOutlinedInput-input': { py: 0.25, px: 1 },
          '& .MuiOutlinedInput-root': { height: 30, borderRadius: 1 },
        }}
      >
        {label ? <InputLabel sx={{ fontSize: 16 }}>{label}</InputLabel> : null}
        <Select
          value={value ?? 'any'}
          variant={'standard'}
          onChange={e => onChange(e.target.value as T)}
          displayEmpty
          inputProps={{ 'aria-label': ariaLabel }}
          renderValue={v => (
            <Typography
              sx={{
                color: renderColorByString(options.find(o => o.value === v)?.label ?? '—'),
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              {options.find(o => o.value === v)?.label ?? '—'}
            </Typography>
          )}
          sx={{ borderColor: 'red' }}
        >
          {options.map(opt => (
            <MenuItem key={opt.value} value={opt.value} sx={{ color: renderColorByString(opt.value) }}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
